import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  pecrId: '',
  siteId: '',
  departmentId: '',
  eIndex: '',
};

export const pecrURLDataSlice = createSlice({
  name: 'pecrURLData',
  initialState,
  reducers: {
    pecrURLData: (state = {}, action) => {
      return { ...state, ...action.payload };
    },
    clearPecrURLData: (state, action) => {
      return initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { pecrURLData, clearPecrURLData } = pecrURLDataSlice.actions;

export default pecrURLDataSlice.reducer;
